/**
 * User-facing labels for healthProfileCompleteSchema field paths.
 *
 * The /api/health-profile/complete route returns 422 with `missingFields`
 * as raw zod paths (energyPattern, cognitiveState, …). Those identifiers
 * are correct on the wire — machine-readable, stable across UI rewrites —
 * but the consumer-facing UI must translate them before rendering.
 *
 * Keep keys in lockstep with `healthProfileCompleteSchema` in `./types.ts`.
 */

export const HEALTH_PROFILE_FIELD_LABELS: Record<string, string> = {
  primaryConcerns: 'Primary concerns',
  activityLevel: 'Activity level',
  dietPattern: 'Diet',
  energyPattern: 'Energy pattern',
  cognitiveState: 'Focus',
  memoryState: 'Memory',
  sleepHoursBand: 'Sleep hours',
  primaryGoals: 'Goal',
};

/** Translate a list of raw zod paths to a friendly comma-joined label list.
 *  Unknown paths fall through verbatim — better to show the raw key than
 *  drop a missing-field hint silently. */
export function labelMissingFields(paths: readonly string[]): string {
  return paths.map((p) => HEALTH_PROFILE_FIELD_LABELS[p] ?? p).join(', ');
}
